export const openExternalLink = (url: string, openInNewTab = false) => {
  if (openInNewTab) {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    window.open(url, '_blank')
  } else {
    window.location.href = url
  }
}
